const updates = [
  { date: '2026.07.28', tag: '新片上线', title: '《爱在午夜降临前》高清修复版独家上线，经典三部曲完整收录' },
  { date: '2026.07.25', tag: '片库更新', title: '夏季浪漫电影专题上线，12部高分二人世界电影一次性放送' },
  { date: '2026.07.20', tag: '观影指南', title: '七夕特辑预告：最适合夫妻共赏的10部催泪爱情片清单出炉' },
  { date: '2026.07.15', tag: '系统升级', title: '播放器全面升级，全站夫妻必看影视实现真正不缓冲高清播放' },
  { date: '2026.07.10', tag: '新片上线', title: '韩国年度浪漫大片《雨天的约定》中文精译版登陆本站' },
  { date: '2026.07.05', tag: '活动预告', title: '「夫妻观影挑战」第三季即将启动，参与赢取限定观影礼包' },
  { date: '2026.06.28', tag: '片库更新', title: '日系纯爱特辑：从《情书》到《花束般的恋爱》一次看个够' },
  { date: '2026.06.20', tag: '网站公告', title: '夫妻影院移动端适配优化完成，手机观影体验大幅提升' },
  { date: '2026.06.12', tag: '新片上线', title: '欧美浪漫喜剧《缘分天注定》20周年纪念版上线夫妻影院' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="text-center mb-12">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            实时动态
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            第一时间获取夫妻影院影片更新、活动资讯与观影指南
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-3 md:left-1/2 top-2 bottom-2 w-px bg-primary-200/60 transform md:-translate-x-px"></div>

          <div className="flex flex-col gap-0">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className={`relative flex flex-col md:flex-row items-start gap-4 md:gap-8 py-6 ${
                  idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right md:pr-0 md:pl-0' : 'md:text-left'} pl-10 md:pl-0`}>
                  <div className="md:hidden absolute left-0 top-8 w-[25px] flex items-center justify-center">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100"></div>
                  </div>
                  <div className="hidden md:block absolute left-1/2 top-8 w-[25px] -translate-x-1/2">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100 mx-auto"></div>
                  </div>
                  <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-2.5 py-0.5 rounded-full mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400 ml-2">{item.date}</span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 mt-1.5 leading-relaxed">
                    {item.title}
                  </h3>
                </div>
                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}